// @ts-check
/** @typedef {import('../types/api').HeroSlide} HeroSlide */

import api from '../utils/apiClient';
import { assertArray } from '../utils/apiGuards';

const heroSlidesService = {
  /**
   * @returns {Promise<HeroSlide[]>}
   */
  getAll: async () => {
    const data = await api.get('/api/admin/hero-slides');
    assertArray(data, 'heroSlidesService.getAll');
    return data;
  },

  /**
   * @param {Object} data
   * @returns {Promise<HeroSlide>}
   */
  create: (data) => api.post('/api/admin/hero-slides', data),

  /**
   * @param {string} id
   * @param {Object} data
   * @returns {Promise<HeroSlide>}
   */
  update: (id, data) => api.patch(`/api/admin/hero-slides/${id}`, data),

  /**
   * @param {string} id
   * @returns {Promise<void>}
   */
  delete: (id) => api.del(`/api/admin/hero-slides/${id}`),

  /**
   * @param {Object[]} items
   * @returns {Promise<Object>}
   */
  reorder: (items) => api.patch('/api/admin/hero-slides/reorder', items),

  /**
   * @param {string} imageUrl
   * @returns {Promise<{title: string, subtitle: string}>}
   */
  generateCopy: (imageUrl) => api.post('/api/admin/hero-slides/generate-copy', { image_url: imageUrl }),
};

export default heroSlidesService;
